import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ResourceService } from './resource';
import { CacheService } from '../cache';
import { Resource } from '../../models/resource';

@Injectable({
  providedIn: 'root',
})
export class CreditTermsService extends ResourceService<Resource> {
  constructor(protected http: HttpClient, protected cache: CacheService) {
    super(http, cache, 'credit-terms');
  }

  /**
   * Create Credit Terms (admin only)
   * POST /credit-terms
   * Header: X-Requested-With: admin
   * Payload: { business: string, wallet: string, credit_limit: number, tenure_days: number }
   */
  createCreditTerms(payload: {
    business: string;
    wallet?: string;
    currency?: string;
    credit_limit: number;
    tenure_days: number;
  }): Observable<any> {
    const headers = new HttpHeaders({ 'X-Requested-With': 'admin' });
    return this.http.post<any>(`${this.endpoint}`, payload, { headers }).pipe(
      map((resp: any) => {
        this.cache.remove(`${this.endpoint}`);
        return resp;
      })
    );
  }

  /**
   * Get Credit Terms
   * GET /credit-terms
   */
  getCreditTerms(params?: any): Observable<any> {
    return this.http.get<any>(`${this.endpoint}`, { params });
  }

  /**
   * GET Approve Credit Limit (admin only)
   * GET /credit-terms/:id/approve
   */
  approveCreditLimit(id: string): Observable<any> {
    return this.http.get<any>(`${this.endpoint}/${id}/approve`);
  }

  /**
   * Get Credit Term by ID
   * GET /credit-terms/:id
   */
  getCreditTermById(id: string): Observable<any> {
    return this.http.get<any>(`${this.endpoint}/${id}`);
  }

  /**
   * Get Credit Term by Business ID
   * GET /credit-terms/business/:business_id
   */
  getCreditTermByBusinessId(businessId: string): Observable<any> {
    return this.http.get<any>(`${this.endpoint}/business/${businessId}`);
  }

}
